import { memo } from 'react';
import { useAsync } from 'react-use';
import { SECTION_ID } from '@zmedia/bm-soccer-ui/constants';
import { ObjectUtils } from '@zmedia/bm-soccer-ui/utils';
import { Element, Icon, Section } from '@zmedia/bm-soccer-ui/components';
import { TeamFormList } from '@zmedia/bm-soccer-ui/modules/match/detail/TeamForm/list';
import {
    URL_SOCCER_PAGE,
} from '@zmedia/bm-soccer-ui/modules/shared';
import { Matches } from '@zmedia/bm-soccer-ui/modules/match';
import { TournamentRanking } from '@zmedia/bm-soccer-ui/modules/tournament/views/ranking';
import Empty from '@zmedia/bm-soccer-ui/modules/shared/components/Empty';
import TeamService from '@zmedia/bm-soccer-ui/service/TeamService';
import { TitleHeader } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleHeader';
import { TitleWrap } from '@zmedia/bm-soccer-ui/modules/shared/components/TitleWrap';
import { renderSections } from '@zmedia/bm-soccer-ui/modules/shared/components/sections';
import styles from './style.module.scss';

const SECTION_MAP = {
    [SECTION_ID.FORM]: Form,
    [SECTION_ID.NEXT_MATCH]: NextMatch,
    [SECTION_ID.STANDING]: Standing,
};

function Form(props: any) {
    return (
        <Section className={styles['team-overview-section']}>
            <TitleHeader>
                <TitleWrap
                    link={`${URL_SOCCER_PAGE.SUBPATH}lich-thi-dau-${props.path}`}
                    title="Phong độ gần đây"
                >
                    <Icon icon="forward-2" />
                </TitleWrap>
            </TitleHeader>
            <TeamFormList {...props} />
        </Section>
    );
}

function NextMatch(props: any) {
    const { item, path } = props;
    return (
        <Section className={styles['team-overview-section']}>
            <TitleHeader>
                <TitleWrap
                    link={`${URL_SOCCER_PAGE.SUBPATH}lich-thi-dau-${path}`}
                    title="Trận đấu tiếp theo"
                >
                    <Icon icon="forward-2" />
                </TitleWrap>
            </TitleHeader>
            <Matches matches={[item]} />
        </Section>
    );
}

function Standing(props: any) {
    const { tournament, teamId } = props;
    return (
        <Element className={styles['team-overview-section']}>
            <TournamentRanking
                {...tournament}
                teamIdSelect={teamId}
                data={props}
            ></TournamentRanking>
        </Element>
    );
}

export function TeamOverview(props: any) {
    let data = props.overviewTeam || {};
    if (ObjectUtils.isEmpty(data)) {
        const state = useAsync(() => TeamService.getOverview(props.id));
        data = state.value?.data || {};
    }

    if (!data.sections) {
        return (
            <Section>
                <Empty content="Chưa có thông tin đội bóng"></Empty>
            </Section>
        );
    }

    data?.sections?.map((section: any) => {
        section.teamId = props.id;
        section.path = props.path;
    });

    return <>{renderSections(data.sections, SECTION_MAP)}</>;
}

export default memo(TeamOverview);
